/* VAEN PDP v4 — fit · route · film · rail · anatomy focus · buy-box helpers */
(function () {
  if (window.__vnp4) return; window.__vnp4 = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  /* ---------- dates ---------- */
  function addBD(d, n) { var x = new Date(d); var k = 0; while (k < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) k++; } return x; }
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function range(a, b) { return a.getMonth() === b.getMonth() ? MONTHS[a.getMonth()] + ' ' + a.getDate() + '–' + b.getDate() : fmt(a) + ' – ' + fmt(b); }
  function dates(min, max) { var t = new Date(); return { today: fmt(t), start: fmt(addBD(t, 1)), ready: range(addBD(t, min), addBD(t, max)) }; }

  /* ---------- scroll helpers ---------- */
  function offsetTop() { var h = $('.vnp-nav'); var hd = $('sticky-header, .header-wrapper, .shopify-section-header-sticky'); var o = 0; if (hd) { var r = hd.getBoundingClientRect(); if (r.bottom > 0 && r.top <= 0) o += r.height; } if (h) o += h.offsetHeight || 0; return o + 8; }
  function scrollToEl(el) { if (!el) return; window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offsetTop(), behavior: reduce ? 'auto' : 'smooth' }); }
  function bindLinks(root) {
    $$('[data-vnp4-top]', root).forEach(function (a) { if (a.__b) return; a.__b = 1; a.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); }); });
    $$('[data-vnp4-samples-link]', root).forEach(function (a) { if (a.__b) return; a.__b = 1; a.addEventListener('click', function (e) { var t = $('[id^="vnp-samp-"]'); if (!t) return; e.preventDefault(); scrollToEl(t); }); });
  }

  /* ---------- units (shared with the option picker) ---------- */
  var unit = 'cm'; var unitSubs = [];
  function onUnit(fn) { unitSubs.push(fn); }
  function setUnit(u, fromPicker) {
    if (u !== 'cm' && u !== 'in') return;
    unit = u; unitSubs.forEach(function (f) { f(u); });
    if (!fromPicker) { var pb = $('.vaen-unit-toggle__button[data-vaen-unit="' + u + '"]'); if (pb && !pb.classList.contains('is-active')) pb.click(); }
  }
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-vaen-unit]'); if (b) setTimeout(function () { setUnit(b.getAttribute('data-vaen-unit'), true); }, 0); });
  function cmTo(v) { return unit === 'cm' ? Math.round(v) : Math.round(v / 2.54 * 2) / 2; }
  function fromUnit(v) { return unit === 'cm' ? v : v * 2.54; }
  function u() { return unit === 'cm' ? 'cm' : 'in'; }

  /* ---------- variant helpers ---------- */
  function sizeRadios() { return $$('variant-selects input[type="radio"]'); }
  function currentSize(values) { var r = sizeRadios().filter(function (x) { return x.checked && values.indexOf(x.value) > -1; })[0]; return r ? r.value : null; }
  function pickSize(val) { var r = sizeRadios().filter(function (x) { return x.value === val; })[0]; if (r && !r.checked) { r.click(); } }
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) setTimeout(function () { document.dispatchEvent(new CustomEvent('vnp4:variant')); }, 30); });

  /* =================== WILL IT FIT =================== */
  function parse(v) { var n = (String(v).match(/\d+(?:[.,]\d+)?/g) || []).map(function (x) { return parseFloat(x.replace(',', '.')); }); if (n.length >= 3) return { L: n[0], D: n[1], H: n[2] }; if (n.length === 2) return { L: n[0], D: n[0], H: n[1] }; return null; }
  function seatsMax(s) { var n = (String(s || '').match(/\d+/g) || []).map(Number); return n.length ? n[n.length - 1] : 0; }
  var NS = 'http://www.w3.org/2000/svg';
  function el(tag, attrs, parent) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (parent) parent.appendChild(e); return e; }

  function initFit(root) {
    if (root.__vnp4) return; root.__vnp4 = 1;
    var sizes = []; try { sizes = JSON.parse($('[data-vnp4-sizes]', root).textContent); } catch (e) { return; }
    sizes = sizes.map(function (s) { var d = parse(s.value); return d ? { value: s.value, seating: s.seating, price: s.price, L: d.L, D: d.D, H: d.H, seats: seatsMax(s.seating) } : null; }).filter(Boolean);
    if (!sizes.length) return;
    var values = sizes.map(function (s) { return s.value; });
    var shape = root.dataset.shape || 'rect', rad = root.dataset.radius, dining = root.dataset.dining === 'true';
    var clr = parseFloat(root.dataset.clearance) || 90, SNUG = 60;
    var plan = $('[data-vnp4-plan]', root), elev = $('[data-vnp4-elev]', root), chipsBox = $('[data-vnp4-chips]', root);
    var status = $('[data-vnp4-status]', root), wallKey = $('[data-vnp4-wall-key]', root);
    var rl = $('[data-vnp4-rl]', root), rw = $('[data-vnp4-rw]', root), out = $('[data-vnp4-room-out]', root);
    var outHint = out ? out.innerHTML : '';
    var cur = sizes.filter(function (s) { return s.value === (currentSize(values) || root.dataset.current); })[0] || sizes[0];
    var room = null; // in cm {L, W}

    function fitOf(s) {
      if (!room) return null;
      var a = Math.min((room.L - s.L) / 2, (room.W - s.D) / 2);
      var b = Math.min((room.W - s.L) / 2, (room.L - s.D) / 2);
      var best = Math.max(a, b); var rot = b > a;
      var tone = best >= clr - 10 ? 'ok' : best >= SNUG ? 'snug' : 'no';
      var ends = rot ? (room.W - s.L) / 2 : (room.L - s.L) / 2, sides = rot ? (room.L - s.D) / 2 : (room.W - s.D) / 2;
      return { tone: tone, min: best, ends: ends, sides: sides, rot: rot };
    }
    var TONE_TXT = { ok: 'Fits', snug: 'Snug', no: 'Too big' };

    // chips
    chipsBox.innerHTML = '';
    var chipEls = sizes.map(function (s) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'vnp4-chip'; b.setAttribute('role', 'radio'); b.dataset.value = s.value;
      b.innerHTML = '<b></b><em></em><span><i></i><i></i></span>';
      b.addEventListener('click', function () { cur = s; pickSize(s.value); render(); });
      chipsBox.appendChild(b); return b;
    });

    function chipText() {
      chipEls.forEach(function (b, i) {
        var s = sizes[i];
        $('b', b).innerHTML = (shape === 'round' && s.L === s.D ? 'Ø ' + cmTo(s.L) : cmTo(s.L) + ' × ' + cmTo(s.D)) + '<small>' + u() + '</small>';
        var spans = $$('span i', b);
        spans[0].textContent = s.seating ? 'Seats ' + String(s.seating).replace('-', '–') : '';
        spans[1].textContent = s.price || '';
        var f = fitOf(s); var em = $('em', b);
        if (f) { b.dataset.fit = f.tone; em.textContent = TONE_TXT[f.tone]; } else { b.removeAttribute('data-fit'); em.textContent = ''; }
        var on = s === cur; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    function nums() {
      var put = function (sel, v) { var e = $(sel, root); if (e) e.innerHTML = cmTo(v) + '<small>' + u() + '</small>'; };
      put('[data-vnp4-l]', cur.L); put('[data-vnp4-d]', cur.D); put('[data-vnp4-h]', cur.H);
      var sw = $('[data-vnp4-seat-wrap]', root); if (sw) { sw.hidden = !cur.seating; $('[data-vnp4-seat]', root).textContent = cur.seating ? String(cur.seating).replace('-', '–') + ' people' : ''; }
      var rm = $('[data-vnp4-room]', root); if (rm) rm.textContent = cmTo(cur.L + clr * 2) + ' × ' + cmTo(cur.D + clr * 2) + ' ' + u();
      $$('[data-vnp4-u]', root).forEach(function (e) { e.textContent = u(); });
    }

    function chairs(g, s) {
      if (!dining || !s.seats) return;
      var cw = 46, cd = 42, off = 12; // chair footprint (cm), tucked overlap
      var put = function (x, y, rot) { var c = el('rect', { x: -cw / 2, y: -cd / 2, width: cw, height: cd, rx: 7, class: 'vnp4-svg-chair', transform: 'translate(' + x + ' ' + y + ') rotate(' + rot + ')' }, g); return c; };
      if (shape === 'round' && s.L === s.D) {
        var R = s.L / 2 + cd / 2 - off;
        for (var i = 0; i < s.seats; i++) { var a = (i / s.seats) * Math.PI * 2 - Math.PI / 2; put(Math.cos(a) * R, Math.sin(a) * R, a * 180 / Math.PI + 90); }
        return;
      }
      var ends = (s.seats >= 6 && s.L >= 160) ? 2 : 0; if (s.seats >= 10 && s.D >= 110) ends = 2;
      var side = Math.ceil((s.seats - ends) / 2);
      var span = s.L - (shape === 'oval' ? s.L * 0.18 : 30);
      for (var k = 0; k < side; k++) {
        var x = -span / 2 + span * ((k + 0.5) / side);
        put(x, -s.D / 2 - cd / 2 + off, 0); put(x, s.D / 2 + cd / 2 - off, 180);
      }
      if (ends) { put(-s.L / 2 - cd / 2 + off, 0, -90); put(s.L / 2 + cd / 2 - off, 0, 90); }
    }

    function table(g, s, cls) {
      if (shape === 'round' && s.L === s.D) return el('circle', { cx: 0, cy: 0, r: s.L / 2, class: cls }, g);
      if (shape === 'oval') return el('rect', { x: -s.L / 2, y: -s.D / 2, width: s.L, height: s.D, rx: s.D / 2, class: cls }, g);
      var r = rad === 'round' ? Math.min(s.D * 0.14, 16) : 3;
      return el('rect', { x: -s.L / 2, y: -s.D / 2, width: s.L, height: s.D, rx: r, class: cls }, g);
    }

    function drawPlan() {
      var s = cur, f = fitOf(s);
      var CL = s.L + clr * 2, CD = s.D + clr * 2;
      var W = CL, H = CD; var rL = 0, rW = 0;
      if (room) { rL = f && f.rot ? room.W : room.L; rW = f && f.rot ? room.L : room.W; W = Math.max(W, rL); H = Math.max(H, rW); }
      var maxL = Math.max.apply(null, sizes.map(function (x) { return x.L + clr * 2; }));
      var maxD = Math.max.apply(null, sizes.map(function (x) { return x.D + clr * 2; }));
      W = Math.max(W, maxL); H = Math.max(H, maxD); // keep a stable scale across sizes
      var pad = 46; var vbW = W + pad * 2, vbH = H + pad * 2;
      var px = (plan.clientWidth || 600) / vbW; var fs = 10.5 / px; // ~10.5px text at any size
      var svg = el('svg', { viewBox: (-vbW / 2) + ' ' + (-vbH / 2) + ' ' + vbW + ' ' + vbH, role: 'img' });
      var g = el('g', {}, svg);
      if (room) el('rect', { x: -rL / 2, y: -rW / 2, width: rL, height: rW, class: 'vnp4-svg-wall' + (f && f.tone !== 'ok' ? ' is-tight' : '') }, g);
      if (dining) el('rect', { x: -CL / 2, y: -CD / 2, width: CL, height: CD, rx: 4, class: 'vnp4-svg-clear' }, g);
      chairs(g, s); table(g, s, 'vnp4-svg-table');
      // dimension lines
      var yT = -s.D / 2 - (dining ? 62 : 22), xR = s.L / 2 + (dining ? 62 : 22);
      if (dining && shape !== 'round') { yT = -CD / 2 + 18; xR = CL / 2 - 18; }
      el('line', { x1: -s.L / 2, y1: yT, x2: s.L / 2, y2: yT, class: 'vnp4-svg-dim' }, g);
      el('line', { x1: -s.L / 2, y1: yT - 5, x2: -s.L / 2, y2: yT + 5, class: 'vnp4-svg-dim' }, g);
      el('line', { x1: s.L / 2, y1: yT - 5, x2: s.L / 2, y2: yT + 5, class: 'vnp4-svg-dim' }, g);
      var tl = el('text', { x: 0, y: yT - fs * 0.7, 'text-anchor': 'middle', class: 'vnp4-svg-t vnp4-svg-t--ink', 'font-size': fs }, g); tl.textContent = 'L ' + cmTo(s.L) + ' ' + u();
      if (!(shape === 'round' && s.L === s.D)) {
        el('line', { x1: xR, y1: -s.D / 2, x2: xR, y2: s.D / 2, class: 'vnp4-svg-dim' }, g);
        el('line', { x1: xR - 5, y1: -s.D / 2, x2: xR + 5, y2: -s.D / 2, class: 'vnp4-svg-dim' }, g);
        el('line', { x1: xR - 5, y1: s.D / 2, x2: xR + 5, y2: s.D / 2, class: 'vnp4-svg-dim' }, g);
        var td = el('text', { x: xR + fs * 0.8, y: fs * 0.35, class: 'vnp4-svg-t vnp4-svg-t--ink', 'font-size': fs }, g); td.textContent = 'D ' + cmTo(s.D);
      }
      if (dining) { var tc = el('text', { x: -CL / 2 + 8, y: CD / 2 - 10, class: 'vnp4-svg-t', 'font-size': fs * 0.92 }, g); tc.textContent = cmTo(CL) + ' × ' + cmTo(CD) + ' ' + u() + ' clearance'; }
      if (room) { var topY = Math.min(-rW / 2, dining ? -CD / 2 : -rW / 2); var tw = el('text', { x: -Math.max(rL, dining ? CL : 0) / 2, y: topY - fs * 0.7, class: 'vnp4-svg-t vnp4-svg-t--ink', 'font-size': fs * 0.92 }, g); tw.textContent = 'Your room ' + cmTo(rL) + ' × ' + cmTo(rW) + ' ' + u(); }
      plan.innerHTML = ''; plan.appendChild(svg);
    }

    function drawElev() {
      if (!elev) return; var s = cur;
      var W = Math.max.apply(null, sizes.map(function (x) { return x.L; })) + 70, Hh = s.H + 34;
      var px = (elev.clientWidth || 260) / W; var fs = 10 / px;
      var svg = el('svg', { viewBox: (-W / 2) + ' ' + (-Hh + 12) + ' ' + W + ' ' + (Hh + 10) });
      el('line', { x1: -W / 2, y1: 0, x2: W / 2, y2: 0, class: 'vnp4-svg-dim' }, svg);
      var top = 4; el('rect', { x: -s.L / 2, y: -s.H, width: s.L, height: top, rx: 1.5, class: 'vnp4-svg-table' }, svg);
      var lw = Math.max(14, Math.min(26, s.L * 0.1)); var inset = s.L * 0.22;
      el('rect', { x: -s.L / 2 + inset - lw / 2, y: -s.H + top, width: lw, height: s.H - top, class: 'vnp4-svg-table', opacity: .85 }, svg);
      el('rect', { x: s.L / 2 - inset - lw / 2, y: -s.H + top, width: lw, height: s.H - top, class: 'vnp4-svg-table', opacity: .85 }, svg);
      var xh = s.L / 2 + 16;
      el('line', { x1: xh, y1: -s.H, x2: xh, y2: 0, class: 'vnp4-svg-dim' }, svg);
      el('line', { x1: xh - 4, y1: -s.H, x2: xh + 4, y2: -s.H, class: 'vnp4-svg-dim' }, svg);
      var t = el('text', { x: xh + 5, y: -s.H / 2 + fs * 0.35, class: 'vnp4-svg-t vnp4-svg-t--ink', 'font-size': fs }, svg); t.textContent = 'H ' + cmTo(s.H);
      var t2 = el('text', { x: -W / 2, y: -s.H - 6, class: 'vnp4-svg-t', 'font-size': fs * 0.9 }, svg); t2.textContent = 'Elevation';
      elev.innerHTML = ''; elev.appendChild(svg);
    }

    function roomText() {
      if (!out) return;
      if (!room) { out.innerHTML = outHint; if (status) status.hidden = true; if (wallKey) wallKey.hidden = true; return; }
      var f = fitOf(cur); var best = null, okish = null;
      sizes.forEach(function (s) { var x = fitOf(s); if (x.tone === 'ok') best = s; if (x.tone !== 'no') okish = s; });
      var lbl = function (s) { return cmTo(s.L) + ' × ' + cmTo(s.D) + ' ' + u(); };
      var m = '';
      if (f.tone === 'ok') m = '<b>' + (f.min >= clr ? 'Fits comfortably.' : 'Fits well.') + '</b> About ' + cmTo(f.sides) + ' ' + u() + ' free along each side and ' + cmTo(f.ends) + ' ' + u() + ' at the ends.';
      else if (f.tone === 'snug') m = '<b>A snug fit.</b> ' + cmTo(f.min) + ' ' + u() + ' on the tightest side — chairs fit, passing behind is tight.' + (best ? ' ' + lbl(best) + ' fits comfortably.' : '');
      else m = '<b>Too tight for this size.</b> ' + (best ? 'The largest comfortable size is ' + lbl(best) + '.' : okish ? lbl(okish) + ' fits, snugly.' : 'None of the standard sizes fit — we can build one to your room.');
      out.innerHTML = m;
      if (status) { status.hidden = false; status.dataset.tone = f.tone; status.textContent = TONE_TXT[f.tone] + (f.tone === 'no' ? '' : ' · ' + cmTo(f.min) + ' ' + u() + ' min'); }
      if (wallKey) wallKey.hidden = false;
    }

    function readRoom() {
      var a = parseFloat(rl && rl.value), b = parseFloat(rw && rw.value);
      room = (a > 0 && b > 0) ? { L: Math.max(fromUnit(a), fromUnit(b)), W: Math.min(fromUnit(a), fromUnit(b)) } : null;
    }
    function render() { chipText(); nums(); drawPlan(); drawElev(); roomText(); }

    [rl, rw].forEach(function (inp) { if (inp) inp.addEventListener('input', function () { readRoom(); render(); }); });
    var form = $('[data-vnp4-room-form]', root); if (form) form.addEventListener('submit', function (e) { e.preventDefault(); });

    $$('[data-vnp4-unit]', root).forEach(function (b) { b.addEventListener('click', function () { setUnit(b.dataset.vnp4Unit); }); });
    onUnit(function (nu) {
      // convert typed room values so the room stays the same physical size
      [rl, rw].forEach(function (inp) { if (inp && inp.value) { var cm = parseFloat(inp.dataset.cm || 0); if (cm) inp.value = nu === 'cm' ? Math.round(cm) : Math.round(cm / 2.54); } });
      $$('[data-vnp4-unit]', root).forEach(function (x) { var on = x.dataset.vnp4Unit === nu; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on); });
      render();
    });
    [rl, rw].forEach(function (inp) { if (inp) inp.addEventListener('input', function () { var v = parseFloat(inp.value); inp.dataset.cm = v > 0 ? fromUnit(v) : ''; }); });

    document.addEventListener('vnp4:variant', function () { var v = currentSize(values); var s = sizes.filter(function (x) { return x.value === v; })[0]; if (s && s !== cur) { cur = s; render(); } });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(render, 150); });
    var pa = $('.vaen-unit-toggle__button.is-active'); if (pa && pa.getAttribute('data-vaen-unit') === 'in') unit = 'in';
    render(); $$('[data-vnp4-unit]', root).forEach(function (x) { x.classList.toggle('is-active', x.dataset.vnp4Unit === unit); });
  }

  /* =================== ORDER TO DOOR =================== */
  function initRoute(sec) {
    if (sec.__vnp4) return; sec.__vnp4 = 1;
    var eta = $('[data-vnp4-eta]', sec); var min = +(eta && eta.dataset.min) || 20, max = +(eta && eta.dataset.max) || 25; var D = dates(min, max);
    if (eta) $('[data-vnp4-eta-v]', eta).textContent = D.ready;
    $$('[data-vnp4-when]', sec).forEach(function (e) { var k = e.dataset.vnp4When; if (k === 'today') e.textContent = 'Today · ' + D.today; else if (k === 'start') e.textContent = 'From ' + D.start; else if (k === 'ready') e.textContent = 'Est. ' + D.ready; });
    var track = $('[data-vnp4-route]', sec); if (!track) return;
    var rail = $('.vnp4-route__rail', track), fill = $('.vnp4-route__fill', track), runner = $('[data-vnp4-runner]', track);
    var stops = $$('.vnp4-stop', track), icons = $$('span', runner); var n = stops.length; if (n < 2) return;
    var centers = [], vertical = false, p = 0, shown = -1;
    function measure() {
      var tr = track.getBoundingClientRect();
      centers = stops.map(function (s) { var r = $('.vnp4-stop__node', s).getBoundingClientRect(); return { x: r.left - tr.left + r.width / 2, y: r.top - tr.top + r.height / 2 }; });
      vertical = Math.abs(centers[n - 1].y - centers[0].y) > Math.abs(centers[n - 1].x - centers[0].x);
      var a = centers[0], b = centers[n - 1];
      if (vertical) { rail.style.cssText = 'left:' + a.x + 'px;top:' + a.y + 'px;width:1px;height:' + (b.y - a.y) + 'px;right:auto;bottom:auto'; }
      else { rail.style.cssText = 'left:' + a.x + 'px;top:' + a.y + 'px;height:1px;width:' + (b.x - a.x) + 'px;right:auto;bottom:auto'; }
    }
    function place() {
      var seg = p * (n - 1), i = Math.min(n - 2, Math.floor(seg)), t = seg - i;
      var a = centers[i], b = centers[i + 1]; var x = a.x + (b.x - a.x) * t, y = a.y + (b.y - a.y) * t;
      runner.style.transform = 'translate(' + (x - 21) + 'px,' + (y - 21) + 'px)';
      var f0 = centers[0], fN = centers[n - 1]; var k = vertical ? (y - f0.y) / (fN.y - f0.y || 1) : (x - f0.x) / (fN.x - f0.x || 1);
      fill.style.transform = vertical ? 'scaleY(' + k + ')' : 'scaleX(' + k + ')';
      var cur = Math.min(n - 1, Math.floor(seg + 0.02));
      stops.forEach(function (s, j) { s.classList.toggle('is-past', j <= cur); s.classList.toggle('is-on', j === cur); });
      if (cur !== shown) { icons.forEach(function (ic, j) { ic.classList.toggle('is-on', j === cur); }); shown = cur; }
    }
    function progress() {
      var r = track.getBoundingClientRect(), vh = window.innerHeight;
      var v = vertical ? (vh * 0.62 - (r.top + centers[0].y)) / ((centers[n - 1].y - centers[0].y) || 1) : (vh * 0.86 - r.top) / (vh * 0.5);
      p = Math.max(0, Math.min(1, v)); if (reduce) p = p > 0 ? 1 : 0; place();
    }
    var ticking = false;
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; progress(); }); } }
    measure(); progress();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); progress(); });
    stops.forEach(function (s, j) { s.addEventListener('mouseenter', function () { if (!vertical && p < j / (n - 1)) { p = j / (n - 1); place(); } }); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); progress(); });
  }

  /* =================== BUY-BOX =================== */
  function initBuy(bb) {
    if (bb.__vnp4) return; bb.__vnp4 = 1;
    var D = dates(+bb.dataset.min || 20, +bb.dataset.max || 25);
    var a = $('[data-vnp4-today]', bb); if (a) a.textContent = D.today;
    var c = $('[data-vnp4-ready]', bb); if (c) c.textContent = D.ready;
    bindLinks(bb);
  }

  /* selected values in the option accordion headers */
  function selValues() {
    $$('[data-vaen-option-section]').forEach(function (row) {
      var title = $('.vaen-variant-row__title', row); if (!title) return;
      var checked = $('input[type="radio"]:checked', row); var tag = $('.vnp4-sel', row);
      if (!tag) { tag = document.createElement('span'); tag.className = 'vnp4-sel'; var tools = $('.vaen-variant-row__tools', row); if (tools) tools.parentNode.insertBefore(tag, tools); else title.parentNode.appendChild(tag); }
      var txt = '';
      if (checked) { var lab = row.querySelector('label[for="' + checked.id + '"]'); var disp = lab && $('[data-vaen-size-display]', lab); txt = (disp ? disp.textContent : (lab ? lab.textContent : checked.value)).replace(/\s+/g, ' ').trim(); }
      if (tag.textContent !== txt) tag.textContent = txt;
    });
  }

  /* =================== FILM =================== */
  function initFilm(sec) {
    if (sec.__vnp4) return; sec.__vnp4 = 1;
    var v = $('video', sec), btn = $('[data-vnp4-film-btn]', sec); var user = false;
    function play() { if (!v.src) v.src = v.dataset.src; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    v.addEventListener('playing', function () { v.classList.add('is-on'); });
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('is-in'); if (!user && !reduce) play(); } else if (!v.paused) v.pause(); }); }, { threshold: 0.25 });
    io.observe(sec);
    if (reduce && btn) btn.setAttribute('aria-pressed', 'true');
    if (btn) btn.addEventListener('click', function () {
      if (v.paused) { user = false; play(); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Pause film'); }
      else { user = true; v.pause(); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Play film'); }
    });
  }

  /* =================== RAIL BAR =================== */
  function initRail(rail) {
    if (rail.__vnp4) return; rail.__vnp4 = 1;
    var bar = $('[data-vnp4-rail-bar]', rail.parentNode); if (!bar) return;
    function upd() { var m = rail.scrollWidth - rail.clientWidth; var w = rail.clientWidth / rail.scrollWidth; bar.style.width = (w * 100) + '%'; bar.style.transform = 'translateX(' + (m > 0 ? (rail.scrollLeft / m) * ((1 / w) - 1) * 100 : 0) + '%)'; }
    rail.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }

  /* =================== ANATOMY FOCUS =================== */
  function initIso(iso) {
    if (iso.__vnp4) return; iso.__vnp4 = 1;
    var labels = $$('.vnp-iso__labels li', iso); if (labels.length < 3) return;
    var i = 0, timer = null, hover = false;
    function set(k) { iso.setAttribute('data-focus', k); }
    function tick() { if (hover) return; i = i % 3 + 1; set(i); }
    function start() { if (timer || reduce) return; timer = setInterval(tick, 2600); tick(); }
    function stop() { clearInterval(timer); timer = null; }
    labels.forEach(function (li, j) { li.addEventListener('mouseenter', function () { hover = true; set(j + 1); }); li.addEventListener('mouseleave', function () { hover = false; }); });
    iso.addEventListener('mouseleave', function () { hover = false; });
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) setTimeout(start, 1400); else { stop(); iso.removeAttribute('data-focus'); } }); }, { threshold: 0.45 }).observe(iso);
  }

  function init() {
    $$('[data-vnp4-fit]').forEach(initFit);
    $$('.vnp4-route').forEach(initRoute);
    $$('.vnp4-bb').forEach(initBuy);
    $$('.vnp4-film').forEach(initFilm);
    $$('[data-vnp4-rail]').forEach(initRail);
    if ($('.vnp4-bb')) { $$('.vnp-iso').forEach(initIso); selValues(); }
    bindLinks(document);
  }
  document.addEventListener('vnp4:variant', function () { setTimeout(selValues, 60); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-vaen-unit]')) setTimeout(selValues, 30); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  // product-info can be re-rendered by the theme after a variant change
  var pi = document.querySelector('[id^="ProductInfo-"]');
  if (pi && window.MutationObserver) { var mt; new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(function () { selValues(); $$('.vnp4-bb').forEach(function (b) { if (!b.__vnp4) initBuy(b); }); }, 80); }).observe(pi, { childList: true, subtree: true }); }
})();
